<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <v-autocomplete
                @update:search-input="SearchCliente"
                v-model="id_cliente"
                :items="clientes"
                :item-text="itemText != null ? itemText : 'nombre_comercial'"
                item-value="id"
                :label="label"
                :dense="dense"
                :filter="filterObject"
                :outlined="outlined"
                :readonly="readonly"
                :rules="rules"
                :multiple="multiple"
                :chips="multiple"
                :small-chips="multiple"
                :deletable-chips="multiple"
                :clearable="multiple"
            >
                <template v-slot:selection="data">
                    <template v-if="multiple">
                        <v-chip
                            v-if="data.index < 2"
                            small
                            close
                            @click:close="remove(data.item)"
                        >
                            {{ dataToShow(data.item) }}
                        </v-chip>
                        <span
                            v-else-if="data.index === 2"
                            class="grey--text caption"
                        >
                            (+{{ (id_cliente || []).length - 2 }} más)
                        </span>
                    </template>
                    <template v-else>{{ dataToShow(data.item) }}</template>
                </template>
                <template v-slot:item="data">
                    <v-list-item-content>
                        {{ dataToShow(data.item) }}
                    </v-list-item-content>
                </template>
                <template v-slot:append-item>
                    <div v-intersect="endIntersect"></div>
                </template>
            </v-autocomplete>
        </div>
    </div>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: [
        "value",
        "extra",
        "label",
        "item-text",
        "enabled",
        "outlined",
        "rol",
        "dense",
        "itemText",
        "readonly",
        "rules",
        "multiple",
    ],
    data() {
        return {
            creado: null,
            id_cliente: this.multiple ? [] : null,
            cliente: {},
            dialog: false,
            users: [],
            update: false,
        };
    },
    watch: {
        value(val) {
            if (this.multiple) {
                this.id_cliente = Array.isArray(val) ? val : val ? [val] : [];
            } else {
                this.id_cliente = val;
            }
        },
        id_cliente(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        remove(item) {
            const id = item && item.id != null ? item.id : item;
            this.id_cliente = (this.id_cliente || []).filter((c) => c !== id);
        },
        dataToShow(item) {
            if (this.itemText != null) {
                return item[this.itemText] ?? "";
            }
            return item.nombre_comercial || item.razon_social || "";
        },
        filterObject(item, queryText) {
            const str = this.dataToShow(item);
            return str.toLowerCase().includes((queryText || "").toLowerCase());
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", {
                rol: this.rol,
                search: val ?? this.id_cliente,
            });
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", { rol: this.rol });
            }
        },
    },
    mounted() {
        this.$store.dispatch("getClientes", { rol: this.rol });
        if (this.value != null) {
            if (this.multiple) {
                this.id_cliente = Array.isArray(this.value)
                    ? this.value
                    : [this.value];
            } else {
                this.id_cliente = this.value;
            }
        }
    },
    computed: {
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;
            if (this.extra?.nombre_comercial != null) {
                clientes_temp.push(this.extra);
            }
            if (this.creado) {
                clientes_temp.push(this.creado);
            }
            return clientes_temp;
        },
    },
};
</script>
